import React, { useEffect, useState } from "react";
import { Check, Book, CreditCard, User, MapPin, X } from "lucide-react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import api from "../utils/api";

function MyClassroomPurchase() {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [contracts, setContracts] = useState({
    distanceSales: false,
    termsOfUse: false,
    parentOrTeacherDeclaration: false,
    kvkkShown: true,
  });
  const [paymentData, setPaymentData] = useState({
    cardHolder: "",
    cardNumber: "",
    expiryMonth: "",
    expiryYear: "",
    cvv: "",
  });
  const [userInfo, setUserInfo] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    address: "",
    city: "Istanbul",
    country: "Turkey",
    zipCode: "",
  });
  const [paymentResponse, setPaymentResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const features = [
    "Her sınıf, MEB müfredatına uygun şekilde 10'ar üniteye ayrılmıştır.",
    "Her ünitede müfredatla uyumlu zengin kelime bilgisi bölümleri yer alır.",
    "Her ünitede müfredata uygun konu anlatımları ve pekiştirici örnekler bulunur.",
    "Her ünitede konuşma becerilerini geliştirmeye yönelik pratikler mevcuttur.",
    "Her ünitede okuma-anlama yetisini destekleyen metinler yer alır.",
    "Ünite öncesi ve sonrası tekrarlı egzersizlerle konular tam olarak pekiştirilir.",
    "Toplam 600 kelime ve 100'den fazla okuma metni ile dil bilgisi temelli konuşma etkinlikleri sunulur.",
    "Egzersizler, basitten zora doğru 3 aşamalı bir öğrenme süreciyle tasarlanmıştır.",
  ];
  const packages = [
    {
      id: "Class 2",
      name: "Class 2 Package",
      description: "2. sınıf seviyesi İngilizce eğitimi",
      price: 999,
      originalPrice: 999,
      discount: "%50",
      indirimliFiyat: 499,
      icon: <Book className="w-8 h-8 text-purple-500" />,
      features: [
        "her üniteye özgü kelimeler",
        "her üniteye özgü konu anlatımı ve örnekler",
        "her üniteye özgü konuşma pratikleri",
        "her üniteye özgü okuma metinleri",
        "her ünite önce ve sonra konu tekrarlı egzersizler",
      ],
    },
    {
      id: "Class 3",
      name: "Class 3 Package",
      description: "3. sınıf seviyesi İngilizce eğitimi",
      price: 999,
      originalPrice: 999,
      discount: "%50",
      indirimliFiyat: 499,
      icon: <Book className="w-8 h-8 text-purple-500" />,
    },
    {
      id: "Class 4",
      name: "Class 4 Package",
      description: "4. sınıf seviyesi İngilizce eğitimi",
      price: 999,
      originalPrice: 999,
      discount: "%50",
      indirimliFiyat: 499,
      icon: <Book className="w-8 h-8 text-purple-500" />,
    },
  ];

  const handlePackageToggle = (packageId) => {
    if (packageId === "all") {
      if (selectedPackages.includes("all")) {
        setSelectedPackages([]);
      } else {
        setSelectedPackages(["all"]);
      }
    } else {
      if (selectedPackages.includes("all")) {
        setSelectedPackages([packageId]);
      } else {
        setSelectedPackages((prev) =>
          prev.includes(packageId)
            ? prev.filter((id) => id !== packageId)
            : [...prev, packageId],
        );
      }
    }
  };

  const getTotalPrice = () => {
    if (selectedPackages.includes("all")) {
      return 624;
    }
    return selectedPackages.reduce((total, packageId) => {
      const pkg = packages.find((p) => p.id === packageId);
      // Orijinal fiyat yerine indirimliFiyat kullanılıyor
      return total + (pkg?.indirimliFiyat || pkg?.price || 0);
    }, 0);
  };

  const getSelectedPackageNames = () => {
    if (selectedPackages.includes("all")) {
      return ["Complete Package - Tüm İçerikler"];
    }
    return selectedPackages.map((id) => {
      const pkg = packages.find((p) => p.id === id);
      return pkg?.name || "";
    });
  };

  const handlePayment = async () => {
    setLoading(true);

    const basketItems = selectedPackages.includes("all")
      ? [
          {
            id: "all_package",
            name: "Complete Package - Classroom",
            price: 624,
            quantity: 1,
            category1: "Education",
            category2: "English Learning",
          },
        ]
      : selectedPackages.map((packageId) => {
          const pkg = packages.find((p) => p.id === packageId);
          return {
            id: packageId,
            name: pkg.name,
            price: pkg.indirimliFiyat || pkg.price,
            quantity: 1,
            category1: "Education",
            category2: "English Learning",
          };
        });

    const paymentRequestData = {
      price: getTotalPrice(),
      paidPrice: getTotalPrice(),
      currency: "TRY",
      paymentCard: {
        cardHolder: paymentData.cardHolder,
        cardNumber: paymentData.cardNumber,
        expiryMonth: paymentData.expiryMonth,
        expiryYear: paymentData.expiryYear,
        cvv: paymentData.cvv,
        registerCard: "0",
      },
      buyer: {
        id: `BY_${Date.now()}`,
        name: userInfo.name,
        surname: userInfo.surname,
        gsmNumber: userInfo.phone,
        email: userInfo.email,
        distanceSales: contracts.distanceSales,
        termsOfUse: contracts.termsOfUse,
        parentOrTeacherDeclaration: contracts.parentOrTeacherDeclaration,
        kvkkShown: contracts.kvkkShown,
        identityNumber: "10274126788",
        lastLoginDate: new Date().toISOString().slice(0, 19).replace("T", " "),
        registrationDate: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
        registrationAddress: userInfo.address,
        ip: "192.168.1.1",
        city: userInfo.city,
        country: userInfo.country,
        zipCode: userInfo.zipCode,
      },
      shippingAddress: {
        recipientName: `${userInfo.name} ${userInfo.surname}`,
        address: userInfo.address,
        city: userInfo.city,
        country: userInfo.country,
        zipCode: userInfo.zipCode,
      },
      billingAddress: {
        recipientName: `${userInfo.name} ${userInfo.surname}`,
        address: userInfo.address,
        city: userInfo.city,
        country: userInfo.country,
        zipCode: userInfo.zipCode,
      },
      basketItems: basketItems,
    };

    try {
      console.log("📤 Gönderilen paymentRequestData:", paymentRequestData);

      const response = await api.post(
        "api/payment/3d-init",
        { paymentRequestData },
        { headers: { "Content-Type": "application/json" } },
      );

      // console.log("📥 Gelen yanıt:", response.data);

      if (response.data.success && response.data.threeDHtmlContent) {
        const htmlContent = response.data.threeDHtmlContent;

        console.log("📄 HTML içeriği uzunluğu:", htmlContent.length);

        // Mevcut belgenin içeriğini tamamen bankanın 3D Secure HTML'i ile değiştir
        document.open();
        document.write(htmlContent);
        document.close();

        setLoading(false);
      } else {
        alert(
          "Ödeme başlatılamadı: " +
            (response.data.message || "Bilinmeyen hata"),
        );
        setLoading(false);
      }
    } catch (error) {
      console.error("❌ Payment Error:", error);
      console.error("❌ Error response:", error.response?.data);
      alert(
        "Ödeme işlemi sırasında bir hata oluştu: " +
          (error.response?.data?.message || error.message),
      );
      setLoading(false);
    }
  };

  const renderStepIndicator = () => (
    <div className="flex items-center justify-center mt-6">
      {[1, 2, 3, 4].map((step) => (
        <React.Fragment key={step}>
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium ${
              step <= currentStep
                ? "bg-purple-500 text-white"
                : "bg-yellow-500 text-white"
            }`}
          >
            {step < currentStep ? <Check className="w-5 h-5" /> : step}
          </div>
          {step < 4 && (
            <div
              className={`w-20 h-1 ${
                step < currentStep ? "bg-purple-500" : "bg-yellow-500"
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );

  const renderPackageSelection = () => (
    <div className="max-w-4xl mx-auto ">
      <h2 className="text-2xl font-bold text-center mb-6">Paket içerikler</h2>
      <div>
        <ul className="text-lg text-gray-600 space-y-3 mb-4">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center">
              <Check className="w-6 h-6 font-semibold text-yellow-500 mr-2 " />
              {feature}
            </li>
          ))}
        </ul>
      </div>
      <h2 className="text-2xl font-bold text-center mb-6">Paket Seçimi</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {packages.map((pkg) => (
          <div
            key={pkg.id}
            className={`relative p-6 rounded-lg border-2 cursor-pointer
               transition-all bg-gray-50 shadow  ${
                 selectedPackages.includes(pkg.id)
                   ? "border-purple-500 bg-blue-50"
                   : "border-gray-200 hover:border-gray-300"
               }`}
            onClick={() => handlePackageToggle(pkg.id)}
          >
            {pkg.discount && (
              <div
                className="absolute -top-2 -right-2 bg-red-500 hover:bg-yellow-500 text-white px-2 py-1
                rounded-full text-xs font-bold"
              >
                {pkg.discount} İNDİRİM
              </div>
            )}

            <div className="flex items-center mb-4">
              <div className="text-blue-600 mr-3">{pkg.icon}</div>
              <h3 className="font-semibold text-lg">{pkg.name}</h3>
            </div>
            <hr className="border-2 border-yellow-500 " />
            <p className="text-gray-600 mb-4">{pkg.description}</p>
            <div>
              {pkg.originalPrice && (
                <span className="text-gray-400 line-through text-sm mr-2">
                  ₺{pkg.originalPrice}
                </span>
              )}
              <span className="text-2xl font-bold text-purple-500">
                ₺{pkg.indirimliFiyat || pkg.price}
              </span>
            </div>
            {selectedPackages.includes(pkg.id) && (
              <div className="absolute top-2 right-2 bg-blue-600 text-white rounded-full p-1">
                <Check className="w-4 h-4" />
              </div>
            )}
          </div>
        ))}
      </div>
      <h2 className="text-2xl font-bold text-center my-6">Sözleşme Şartları</h2>

      <div className="flex flex-col gap-4 bg-white p-4 rounded-lg border">
        {/* Checkbox 1 */}
        <label className="flex gap-3 items-start cursor-pointer">
          <input
            type="checkbox"
            className="mt-1"
            required
            checked={contracts.distanceSales}
            onChange={(e) =>
              setContracts((prev) => ({
                ...prev,
                distanceSales: e.target.checked,
              }))
            }
          />
          <span className="text-sm text-gray-600">
            <Link to="/mesafeli-satis" className="text-blue-600 underline">
              Mesafeli Satış Sözleşmesi
            </Link>
            'ni okudum, kabul ediyorum
          </span>
        </label>

        {/* Checkbox 2 */}
        <label className="flex gap-3 items-start cursor-pointer">
          <input
            type="checkbox"
            className="mt-1"
            required
            checked={contracts.termsOfUse}
            onChange={(e) =>
              setContracts((prev) => ({
                ...prev,
                termsOfUse: e.target.checked,
              }))
            }
          />
          <span className="text-sm text-gray-600">
            <Link to="/kullanim-sartlari" className="text-blue-600 underline">
              Kullanım Şartları
            </Link>
            'nı okudum, kabul ediyorum
          </span>
        </label>

        {/* Checkbox 3 */}
        <label className="flex gap-3 items-start cursor-pointer">
          <input
            type="checkbox"
            className="mt-1"
            required
            checked={contracts.parentOrTeacherDeclaration}
            onChange={(e) =>
              setContracts((prev) => ({
                ...prev,
                parentOrTeacherDeclaration: e.target.checked,
              }))
            }
          />
          <span className="text-sm text-gray-600">
            Seçtiğim öğrencinin velisi veya öğretmeni olduğumu beyan ediyorum
          </span>
        </label>

        <p className="text-xs text-gray-400 italic px-7">
          <Link to="/kvkk" className="underline">
            KVKK Aydınlatma Metni
          </Link>{" "}
          hakkında bilgilendirildim
        </p>
      </div>

      {/* Summary and Button Section */}
      {selectedPackages.length > 0 &&
        contracts.distanceSales &&
        contracts.termsOfUse &&
        contracts.parentOrTeacherDeclaration && (
          <div className="mt-8 p-6 bg-purple-50 rounded-xl border-2 border-purple-100 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <h3 className="font-bold text-purple-900 mb-3">Sipariş Özeti:</h3>
            <ul className="mb-6 space-y-1">
              {getSelectedPackageNames().map((name, index) => (
                <li key={index} className="text-purple-700 flex items-center">
                  <span className="mr-2">✓</span> {name}
                </li>
              ))}
            </ul>

            <div className="flex justify-between items-center border-t border-purple-200 pt-4">
              <div>
                <p className="text-sm text-purple-600">Ödenecek Toplam</p>
                <span className="text-3xl font-black text-purple-900">
                  ₺{getTotalPrice()}
                </span>
              </div>
              <button
                onClick={() => setCurrentStep(2)}
                className="px-8 py-3 bg-purple-600 text-white font-bold rounded-xl
                 hover:bg-purple-700 transform hover:scale-105 transition-all shadow-lg"
              >
                Ödemeye Geç
              </button>
            </div>
          </div>
        )}
    </div>
  );

  const renderUserInfo = () => (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-center mb-6">Kişisel Bilgiler</h2>
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Ad
            </label>
            <input
              type="text"
              value={userInfo.name}
              onChange={(e) =>
                setUserInfo({ ...userInfo, name: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md 
              focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Soyad
            </label>
            <input
              type="text"
              value={userInfo.surname}
              onChange={(e) =>
                setUserInfo({ ...userInfo, surname: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none 
              focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              E-mail
            </label>
            <input
              type="email"
              value={userInfo.email}
              onChange={(e) =>
                setUserInfo({ ...userInfo, email: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md
               focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Telefon
            </label>
            <input
              type="tel"
              value={userInfo.phone}
              onChange={(e) =>
                setUserInfo({ ...userInfo, phone: e.target.value })
              }
              placeholder="+905xxxxxxxxx"
              className="w-full px-3 py-2 border border-gray-300 rounded-md 
              focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Adres
            </label>
            <textarea
              value={userInfo.address}
              onChange={(e) =>
                setUserInfo({ ...userInfo, address: e.target.value })
              }
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md 
              focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Şehir
            </label>
            <input
              type="text"
              value={userInfo.city}
              onChange={(e) =>
                setUserInfo({ ...userInfo, city: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md
               focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Posta Kodu
            </label>
            <input
              type="text"
              value={userInfo.zipCode}
              onChange={(e) =>
                setUserInfo({ ...userInfo, zipCode: e.target.value })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md
               focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
        </div>

        <div className="flex justify-between mt-6">
          <button
            onClick={() => setCurrentStep(1)}
            className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg
               bg-purple-500 hover:bg-purple-700 transition-colors"
          >
            Geri
          </button>
          <button
            onClick={() => setCurrentStep(3)}
            disabled={
              !userInfo.name ||
              !userInfo.surname ||
              !userInfo.email ||
              !userInfo.phone ||
              !userInfo.address
            }
            className="px-6 py-2 bg-purple-500 text-white rounded-lg
              hover:bg-purple-700 disabled:bg-gray-300 transition-colors"
          >
            Devam Et
          </button>
        </div>
      </div>
    </div>
  );

  const renderPayment = () => (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-center mb-6">Ödeme Bilgileri</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Ödeme Formu */}
        <div className="bg-gray-50 p-6 rounded-lg shadow-lg">
          <div className="flex items-center mb-4">
            <CreditCard className="w-6 h-6 text-purple-500 mr-2" />
            <h3 className="text-lg font-semibold">Kredi Kartı Bilgileri</h3>
          </div>
          <div className="bg-white p-1 rounded border border-gray-100 shadow-sm">
            <img
              src="/odeme logo.png"
              alt="Ödeme Yöntemleri"
              className="h-8 object-contain"
            />
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Kart Sahibi
              </label>
              <input
                type="text"
                value={paymentData.cardHolder}
                onChange={(e) =>
                  setPaymentData({ ...paymentData, cardHolder: e.target.value })
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md
                focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Kart Numarası
              </label>
              <input
                type="text"
                value={paymentData.cardNumber}
                onChange={(e) =>
                  setPaymentData({ ...paymentData, cardNumber: e.target.value })
                }
                placeholder="1234 5678 9012 3456"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none
                focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <div className="grid grid-cols-3 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ay
                </label>
                <select
                  value={paymentData.expiryMonth}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      expiryMonth: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md
                    focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  <option value="">Ay</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i} value={String(i + 1).padStart(2, "0")}>
                      {String(i + 1).padStart(2, "0")}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Yıl
                </label>
                <select
                  value={paymentData.expiryYear}
                  onChange={(e) =>
                    setPaymentData({
                      ...paymentData,
                      expiryYear: e.target.value,
                    })
                  }
                  className="w-full px-3 py-2 border border-gray-300
                  rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  <option value="">Yıl</option>
                  {[...Array(10)].map((_, i) => {
                    const year = new Date().getFullYear() + i;
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  CVV
                </label>
                <input
                  type="text"
                  value={paymentData.cvv}
                  onChange={(e) =>
                    setPaymentData({ ...paymentData, cvv: e.target.value })
                  }
                  placeholder="123"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md
                   focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Sipariş Özeti */}
        <div className="bg-gray-50 p-6 rounded-lg shadow-lg">
          <h3 className="text-lg font-semibold mb-4">Sipariş Özeti</h3>

          <div className="space-y-3 mb-4">
            {getSelectedPackageNames().map((name, index) => {
              const pkg = packages.find((p) => p.name === name);
              return (
                <div key={index} className="flex justify-between">
                  <span className="text-gray-600">{name}</span>
                  <span className="font-medium">
                    ₺
                    {selectedPackages.includes("all")
                      ? 624
                      : pkg?.indirimliFiyat || pkg?.price || 0}
                  </span>
                </div>
              );
            })}
          </div>

          <div className="border-t-2 border-yellow-500 pt-3 mb-6">
            <div className="flex justify-between text-xl font-bold">
              <span>Toplam</span>
              <span className="text-purple-500">₺{getTotalPrice()}</span>
            </div>
          </div>

          <div className="space-y-2 text-sm text-gray-600 mb-6">
            <div className="flex items-center">
              <User className="w-4 h-4 mr-2 text-purple-500" />
              {userInfo.name} {userInfo.surname}
            </div>
            <div className="flex items-center">
              <MapPin className="w-4 h-4 mr-2 text-purple-500" />
              {userInfo.city}, {userInfo.country}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={() => setCurrentStep(2)}
              className="w-full px-4 py-2 border border-gray-300 text-white
              rounded-lg bg-purple-500 hover:bg-purple-700 transition-colors"
            >
              Geri
            </button>
            <button
              onClick={handlePayment}
              disabled={
                loading ||
                !paymentData.cardHolder ||
                !paymentData.cardNumber ||
                !paymentData.expiryMonth ||
                !paymentData.expiryYear ||
                !paymentData.cvv
              }
              className="w-full px-4 py-2 bg-purple-500 text-white rounded-lg
               hover:bg-purple-700 disabled:bg-gray-300 transition-colors"
            >
              {loading
                ? "İşleniyor..."
                : `₺${getTotalPrice()} - Ödemeyi Tamamla`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSuccess = () => (
    <div className="max-w-2xl mx-auto text-center">
      {paymentResponse?.success ? (
        <div className="bg-green-50 p-8 rounded-lg">
          <div
            className="w-16 h-16 bg-green-100 rounded-full flex 
          items-center justify-center mx-auto mb-4"
          >
            <Check className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-green-800 mb-4">
            Ödeme Başarılı!
          </h2>
          <p className="text-green-600 mb-6">
            Paketleriniz başarıyla satın alındı. Kısa süre içinde e-posta
            adresinize erişim bilgileri gönderilecektir.
          </p>
          <div className="bg-white p-4 rounded-lg mb-6">
            <h3 className="font-semibold mb-2">Satın Alınan Paketler:</h3>
            <ul className="text-left">
              {getSelectedPackageNames().map((name, index) => (
                <li key={index} className="text-gray-700">
                  • {name}
                </li>
              ))}
            </ul>
            <div className="mt-4 pt-4 border-t">
              <span className="text-xl font-bold">
                Toplam: ₺{getTotalPrice()}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-red-50 p-8 rounded-lg">
          <h2 className="text-2xl font-bold text-red-800 mb-4">
            Ödeme Başarısız!
          </h2>
          <p className="text-red-600 mb-6">
            {paymentResponse?.message ||
              "Ödeme işlemi sırasında bir hata oluştu."}
          </p>
          <button
            onClick={() => setCurrentStep(3)}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Tekrar Dene
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div
      className="min-h-screen  py-8"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      <div className="container mx-auto px-4">
        <div
          className="
          bg-yellow-500  flex flex-row items-center justify-between
           gap-4 px-6 py-4 rounded-xl -mt-4 "
        >
          <div className="flex flex-col text-left">
            <h1
              className="
                text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-1 "
            >
              Classroom - İngilizce Paketleri
            </h1>

            <p className="text-gray-700 text-xs sm:text-sm md:text-base">
              İlkokul öğrencileri için kapsamlı İngilizce eğitim paketleri
            </p>
          </div>

          <div className="flex justify-end mb-8 ">
            <button
              className="
              bg-white w-12 h-12 px-3 py-2 rounded-full text-red-700  font-semibold 
              hover:bg-red-500 hover:text-white "
              onClick={() => navigate("/HomePage")}
            >
              <X />
            </button>
          </div>
        </div>

        {renderStepIndicator()}

        <div className="bg-white rounded-xl shadow-lg p-8 mt-4">
          {currentStep === 1 && renderPackageSelection()}
          {currentStep === 2 && renderUserInfo()}
          {currentStep === 3 && renderPayment()}
          {currentStep === 4 && renderSuccess()}
        </div>
      </div>
    </div>
  );
}

export default MyClassroomPurchase;
